import React from "react";
import Backgroundimage from "../../assets/images/background/image-4.jpg";
import { Link } from "react-router-dom";
import logonew from "../../assets/images/logo.png";
import tripAdvisorIcon from "../../assets/images/icons/tripadvisor.png";

function Main() {
    return (
        <>
            <footer className="main-footer">
                <div
                    className="image-layer"
                    style={{ backgroundImage: `url(${Backgroundimage})` }}
                >
                    {" "}
                </div>
                <div className="upper-section">
                    <div className="auto-container">
                        <div
                            className="row clearfix"
                            style={{ justifyContent: "center" }}
                        >
                            <div className="footer-col info-col col-lg-6 col-md-6 col-sm-6">
                                <div
                                    className="inner wow fadeInUp"
                                    data-wow-delay="0ms"
                                    data-wow-duration="1500ms"
                                >
                                    <div className="content">
                                        <div className="logo">
                                            <Link
                                                to="/"
                                                title="Chez François Restaurant"
                                            >
                                                <img
                                                    src={logonew}
                                                    alt=""
                                                    title="Chez François Restaurant"
                                                />
                                            </Link>
                                        </div>
                                        <div className="info">
                                            <ul>
                                                <li>
                                                    1716 BOW VALLEY TRAIL,
                                                    CHATEAU CANMORE QUALITY
                                                    RESORT, CANMORE, CA
                                                </li>
                                                <br/>
                                                <li>
                                                    Open : 07:00 am - 02:30 pm
                                                </li>
                                                <li>
                                                    Weekends : 07:00 am - 03:00 pm
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="separator">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                        <div className="link link-btn">
                                            <Link
                                                to="https://www.opentable.ca/restref/client/?rid=1411912&restref=1411912&lang=en-CA&color=1&r3uid=cfe&dark=false&partysize=6&datetime=2025-08-21T22%3A30&ot_source=Restaurant%20website&corrid=497d104c-c015-4655-bcf6-4abdfe7c9bc0"
                                                className="theme-btn btn-style-one clearfix"
                                            >
                                                <span className="btn-wrap">
                                                    <span className="text-one">
                                                        book a table
                                                    </span>
                                                    <span className="text-two">
                                                        book a table
                                                    </span>
                                                </span>
                                            </Link>
                                            <div className="social-icons">
                                                <Link
                                                    to="https://www.facebook.com/chezfrancoiscanmore/"
                                                    target="_blank"
                                                    aria-label="Facebook"
                                                >
                                                    <i className="fab fa-facebook-f"></i>
                                                </Link>

                                                <Link
                                                    to="https://www.instagram.com/chez.francois/?hl=en"
                                                    target="_blank"
                                                    aria-label="Instagram"
                                                >
                                                    <i className="fab fa-instagram"></i>
                                                </Link>

                                                <Link
                                                    to="https://www.tripadvisor.ca/Restaurant_Review-g181727-d17506505-Reviews-Chez_Francois_Restaurant-Canmore_Kananaskis_Country_Alberta.html"
                                                    target="_blank"
                                                    aria-label="TripAdvisor"
                                                >
                                                    <img src={tripAdvisorIcon} alt="TripAdvisor" />
                                                </Link>

                                                <Link
                                                    to="https://www.google.com/maps/place/Chez+Francois+Restaurant+and+Patio/"
                                                    target="_blank"
                                                    aria-label="Google Maps"
                                                >
                                                    <i className="fas fa-map-marker-alt"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="scroll-to-top scroll-to-target" data-target="html">
                <span className="icon fa fa-angle-up"></span>
            </div>
        </>
    );
}

export default Main;
